<template>
    <div class="wallet_save">
        <div class="top">
            <div class="title">{{ text('wallet_topup.select_account') }}</div>
            <WalletList v-model:activeWallet="activeWallet" />            
            <div class="input">
                <span>{{ text('wallet_topup.amount') }}</span>
                <input type="text" v-model="amount" inputmode="numeric" pattern="[0-9\s]{13,19}" placeholder="0">
            </div>
        </div>
        <div class="error">{{ errorMessage }}</div>

        <template v-if="envName === 'stater'">
            <button class="main_btn" @click="TopUp()">
                <img height="24" src="@/assets/images/sbp_logo.svg" alt="sbp"  style="vertical-align: middle;padding-right: 8px;" /> 
                <span style="vertical-align: middle;">СБП</span>
            </button>  
            <button class="main_btn" @click="cashModalActive = true" >
                <img height="24" src="@/assets/images/cash.svg" alt="sbp" style="vertical-align: middle;padding-right: 8px;" /> 
                <span style="vertical-align: middle;">Пополнение наличными</span>
            </button>        
            <TextModal 
                @closeModal="cashModalActive = false" 
                v-if="cashModalActive"
                title="" 
                :text="cashModalText" 
            />                               
        </template>
        <template v-else>                                    
            <div class="payment_security_section">
                <div class="payment_methods">
                    <img src="@/assets/images/visa_logo.svg" alt="Visa" />
                    <img src="@/assets/images/mastercard_logo.svg" alt="MasterCard" />
                </div>
            </div>            

            <div class="terms_checkbox">
                <label class="checkbox_container">
                    <input type="checkbox" v-model="termsAccepted" />
                    <span>{{text('wallet_topup.accept_the')}}</span>
                    <a :href="termsOfUse" target="_blank">{{text('wallet_topup.terms_of_use')}}</a>
                </label>                
            </div>            
            <Button @btnClick="TopUp()" :title="text('wallet_topup.top_up')" :disabled="topUpDisabled || !termsAccepted ? '': disabled" />
        </template>



        <PayModal 
            :stage="modalStage"
            :errorMessage="errorMessage"
            :sucessMessage="text('wallet_topup.success')"
            @enterPin="doWithdrawal" 
            @closeModal="closeModal()"             
            v-if="modalActive" 
            :pinCode="pinCode"
        />
    </div>
</template>

<script>
import WalletList from '@/components/WalletList.vue'
import Button from '@/components/Button.vue'
import PayModal from '@/components/PayModal.vue'
import TextModal from '@/components/TextModal.vue'
import termsOfUse from '@/assets/grok/policy/_grok_terms_of_use.pdf'

const cashModalText = `
<h2>Пополнение счёта наличными в кассе РНКО «СТАТЕРА» (ООО)</h2>

<p>Для пополнения счёта наличными необходимо лично обратиться в отделение РНКО «СТАТЕРА» (ООО) по адресу:</p>

<address>
  384900, Республика Абхазия,<br>
  г. Сухум, ул. Лакоба, д. 34
</address>

<p>При обращении в кассу необходимо предоставить:</p>

<ul>
  <li>Паспорт на имя владельца счёта.</li>
  <li>Информацию для оформления заявки:
    <ul>
      <li>Фамилия, имя, отчество владельца счёта;</li>
      <li>Сумма пополнения;</li>
      <li>Номер счёта или иные необходимые реквизиты.</li>
    </ul>
  </li>
</ul>

<p>Сотрудник кассы оформит заявку на основании предоставленных данных. После проверки документов будет осуществлено пополнение счёта наличными.</p>

<p><strong>Важно:</strong> паспортные данные должны совпадать с информацией, указанной в электронном кошельке.</p>

`

export default {
    name: "WalletTopUp",
    components: {
        WalletList,
        Button,
        PayModal,
        TextModal,
    },
    data () {
        return {
            amount: '',
            errorMessage: '',
            modal_active: false,
            topUpDisabled: false,
            activeWallet: this.$store.state.currentWallet,
            cashModalActive: false,
            cashModalText: cashModalText,
            termsAccepted: false,
            termsOfUse: termsOfUse,
        }
    },
    computed: {
        authToken () {
            return this.$store.state.authToken
        },
    },
    methods: {
        async TopUp () {
            // this.modal_active = true;
            this.topUpDisabled = true
            
            const { data } = await this.$http.post(
                '/v2/wallet/top-up',
                {
                    "amount": this.amount,
                    "currency_code": this.activeWallet.currency_code
                },
                {                    
                    "headers": {
                        "Authorization": "Token " + this.authToken
                    },
                    validateStatus: () => true               
                }
            );
            if (data.status === "error") {
                // this.errorMessage = data.message
                this.errorMessage = this.text('wallet_topup.error')
                this.topUpDisabled = false
            } else {
                window.location = data.url
            }
            // this.topUpDisabled = false;
        },
        closeModal () {
            this.modal_active = false;
        }
    }
}
</script>

<style scoped>
.checkbox_container {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 24px 0;
    padding-left: 24px;
}

.checkbox_container input[type="checkbox"] {
    margin: 0;
}

.payment_security_section {
    background-color: white;
    padding: 16px;    
    margin: 0 24px 0 24px;
    border-radius: 12px;        
}

.payment_methods {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    opacity: 0.8;
}

.payment_methods img {
    flex: 1;
    max-width: 35%;
    height: auto;
}
</style>